import { ValidationErrors } from '@angular/forms';

export type RangeValidatorError = (ValidationErrors & { range?: { min?: number; max?: number; actual?: number } }) | null;
